<div class="reports-list-container">
  <div class="header">
    <h1>Reports</h1>
    <p class="subtitle">Access and generate reports for your dealership</p>
  </div>

  <div class="filter-section">
    <div class="category-filters">
      <button
        *ngFor="let category of categories"
        [class.active]="selectedCategory === category"
        (click)="filterByCategory(category)"
        class="filter-btn">
        {{ category }}
      </button>
    </div>
  </div>

  <div class="reports-grid">
    <div *ngFor="let report of filteredReports" class="report-card" (click)="viewReport(report.id)">
      <div class="report-icon">
        <mat-icon>{{ report.icon }}</mat-icon>
      </div>
      <div class="report-content">
        <h3>{{ report.name }}</h3>
        <p class="category-badge">{{ report.category }}</p>
        <p class="description">{{ report.description }}</p>
      </div>
      <div class="report-actions">
        <button mat-icon-button matTooltip="View Report">
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="filteredReports.length === 0" class="no-reports">
    <mat-icon>inbox</mat-icon>
    <p>No reports found in this category</p>
  </div>
</div>
